import { useEffect } from "react";
import type { Common } from "@beautypie/segment";

import { isBrowser } from "@shared/utils.environment";

import { getPageName } from "data/tracking/segment/helpers";
import { pageContextVar } from "lib/apollo/variables/segment";
import { useRouter } from "lib/router";
import { useLocale } from "./useLocale";
import { getRegion } from "@shared/utils.locale";

interface ContextPageParams {
  name: string;
  path: string;
  window: Window;
}

const createContextPage = ({ name, path, window }: ContextPageParams) => {
  const referrer =
    window.document.referrer === "" ? undefined : window.document.referrer;
  const context = {
    page: {
      path,
      title: document.title,
      name,
      search: window.location.search,
      url: window.location.href,
      referrer
    }
  } as Common["context"];
  return context;
};

export const usePageSet = (): void => {
  const { beforeUnload } = useRouter();
  const locale = useLocale();
  const countryTypeLocale = getRegion(locale);

  useEffect(() => {
    const storage = window.sessionStorage;
    let name = "";
    let path = "";
    const handleRouteChange = () => {
      if (!storage) return true;
      if (isBrowser()) {
        path = window.location.pathname;
        name = getPageName(path, path, countryTypeLocale);
      }

      const contextPage = createContextPage({ name, path, window });
      pageContextVar(contextPage);
    };

    beforeUnload(handleRouteChange);
    if (isBrowser()) {
      path = window.location.pathname;
      name = getPageName(path, path, countryTypeLocale);
    }

    const contextPage = createContextPage({ name, path, window });
    pageContextVar(contextPage);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
